<template>
  <b-container>
    <b-row align-h="center" class="mt-5">

      <b-col cols="12">
        <b-card-header class="card-main-header">
            <h3 class="text-center">Admin Panel</h3>
        </b-card-header>
        <b-card class="card-main p-3 text-center">

          <div class="float-left">
            <a href="admin/user/create" class="btn btn-md btn-primary d-inline">
              Add Donator
            </a>
            <b-form-checkbox class="d-inline pl-5" v-model="activeOnly" name="activeOnly" value="1" unchecked-value="0" v-on:input="refreshTable()">
              Only Active
            </b-form-checkbox>
            <b-form-checkbox class="d-inline pl-5" v-model="noPermanent" name="noPermanent" value="1" unchecked-value="0" v-on:input="refreshTable()">
              No Permanent
            </b-form-checkbox>
          </div>

          <b-col lg="3" class="float-right mb-3">
            <b-input-group size="sm">
              <b-form-input class="input-dark" v-model="filter" type="search" id="filterInput" placeholder="Type to Search"></b-form-input>
              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-col>

          <b-table id="donators" ref="donators" hover :busy.sync="isLoading" :per-page="0" :fields="fields" :current-page="currentPage" :items="getDonators"
          :filter="filter" show-empty>

            <template v-slot:cell(avatar_url)="data">
              <img class="rounded-circle" :src="data.value" width="32" heigth="32">
            </template>

            <template v-slot:cell(player_id)="data">
              <a :href="`admin/user/${data.value}/edit`" class="btn btn-sm btn-warning">
                Edit
              </a>
            </template>

            <template :empty="scope">
              <h5>No records found</h5>
            </template>

            <template v-slot:table-busy>
              <div class="text-center text-secondary my-2">
                <b-spinner class="align-middle"></b-spinner>
                <strong>Loading...</strong>
              </div>
            </template>

          </b-table>

          <b-pagination v-model="currentPage" :per-page="perPage" :total-rows="totalItems" aria-controls="donators"></b-pagination>

        </b-card>
      </b-col>
    </b-row>
  </b-container>
</template>


<script>
import moment from 'moment'
import UserApi from '@/services/UserApi'
import EventBus from '@/services/EventBus'

export default {
  data() {
    return {
      isLoading: false,
      sortBy: 'created_at',
      sortDesc: true,
      currentPage: 1,
      perPage: 10,
      activeOnly: 0,
      noPermanent: 0,
      totalItems: null,
      filter: '',
      fields: [
        {
          key: 'avatar_url',
          label: 'Avatar'
        },
        {
          key: 'username',
          label: 'Username',
          sortable: true
        },
        {
          key: 'steam_id',
          label: 'SteamID',
          sortable: true
        },
        {
          key: 'total_donated',
          label: 'Total Donated',
          formatter: (value, key, item) => {
            if(value == null) {
              return 0 + ' $'
            } else {
              return value + ' $'
            }
          },
          sortable: true
        },
        {
          key: 'expiration_date',
          label: 'Expiry',
          formatter: (value, key, item) => {
            if(value == null && !item.permanent) {
              return 'None'
            } else if(moment(item.expiration_date).isBefore(new Date())) {
              return moment(item.expiration_date).fromNow() + ' (Expired)'
            } if(item.permanent) {
              return 'Permanent'
            } else {
              return moment(value).fromNow();
            }
          },
          sortable: true
        },
        {
          key: 'remove',
          label: 'Removal Pending',
          formatter: (value, key, item) => {
            if(value) {
              return 'True';
            } else {
              return 'False';
            }
          },
          sortable: true
        },
        {
          key: 'player_id',
          label: 'Actions'
        }
      ],
    }
  },
  methods: {
    getDonators(ctx) {
      return UserApi.getUsers(this.currentPage, this.perPage, ctx.sortBy, ctx.sortDesc, ctx.filter, this.activeOnly, this.noPermanent).then(result => {
        this.totalItems = result.count;
        return result.data;
      }).catch(error => {
        EventBus.$emit('Error', error);
        return [];
      });
    },
    refreshTable() {
      this.$refs.donators.refresh();
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Admin/Admin.vue